import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

import ProgressBar from "../ProgressBar/ProgressBar";
import Table from "../Table/Table";

const API_URL = `${API_BASE_URL}/api/today/`;

function Today() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchToday() {
      const startedAt = performance.now();

      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error(`Request failed: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (requestError) {
        setError(requestError.message);
      } finally {
        console.log(
          `fetchToday took ${(performance.now() - startedAt).toFixed(2)} ms`,
        );
        setLoading(false);
      }
    }

    fetchToday();
  }, []);

  if (loading) {
    return <p>Loading today's signal...</p>;
  }

  if (error) {
    return <p>Could not load today's signal: {error}</p>;
  }

  const progressBars = [
    {
      canvasId: "progressCanvas1",
      value: data.all_models_signal,
      minValue: 0,
      maxValue: 100,
      progressValueId: "progressValue1",
      minValueId: "minValue1",
      maxValueId: "maxValue1",
      barLabel: "SIGNAL",
    },
    {
      canvasId: "progressCanvas2",
      value: data.all_models_signal_strength,
      minValue: 0,
      maxValue: 100,
      progressValueId: "progressValue2",
      minValueId: "minValue2",
      maxValueId: "maxValue2",
      barLabel: "SIGNAL STRENGTH",
    },
    {
      canvasId: "progressCanvas3",
      value: data.all_models_leverage,
      minValue: 0,
      maxValue: 10,
      progressValueId: "progressValue3",
      minValueId: "minValue3",
      maxValueId: "maxValue3",
      barLabel: "LEVERAGE",
    },
  ];

  return (
    <>
      <div className="h1-container">
        <h1>TODAY'S SIGNAL</h1>
      </div>

      {/* <div className="progress-container">
        {progressBars.map((item) => (
          <ProgressBar key={item.canvasId} {...item} />
        ))}
      </div> */}

      <Table data={data} />
    </>
  );
}

export default Today;
